// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-input::-webkit-inner-spin-button {\n    opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
